import { logger } from '@main/core-ui';

/**
 * Change the favicon asset
 *
 * @param url - The url of the favicon asset
 */
export function changeFavicon(url: string): void {
  const favicon: any = document.getElementById('favicon'); // eslint-disable-line @typescript-eslint/no-explicit-any
  if (favicon) {
    favicon.href = url;
  } else {
    logger.log('No favicon to set!');
  }
}
